import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { INDRAIbeAdminConfigService } from '@ibe.services/ibeadmin-config.service';
import { PaymentService } from '../payment.service';
import { takeWhile } from 'rxjs/operators';
import { INDRATotalFlightPrice } from '@ibe.models/flight-price.model.indra.lib';


@Component({
  selector: 'app-cardless',
  templateUrl: './cardless.indra.component.html',
})

export class INDRACardlessComponent implements OnInit, OnDestroy {
  myScriptElement: HTMLScriptElement;
  myScriptElement1: HTMLScriptElement;

  cardlessBrandTAP: string;
  cardlessEnvironment: string;
  cardlessClassOfService: string;
  carldessProduct: string;
  cardlessUtmCampaign: string;
  cardlessUiMetadata: any;
  cardlessStrategy: string;
  cardlessRedirectURL: string;

  @Input() cardlessToken: string;

  isAlive: boolean = true;
  totalFlightPrice: INDRATotalFlightPrice;

  constructor(
    private ibeAdminConfigService: INDRAIbeAdminConfigService,
    private paymentService: PaymentService
  ) {  }

  ngOnInit(): void {
    this.INDRA_setCardlessVariables();

    this.paymentService.totalFlightPrice
			.pipe(takeWhile(() => this.isAlive))
			.subscribe(totalFlightPrice => {
				this.totalFlightPrice = totalFlightPrice;
        this.INDRA_setCardlessScript();
			});

  }

  ngOnDestroy(): void {
    this.isAlive = false;
  }

  TAP_convert(n: number): string{    
    const e2 = n * 1e2
    const e2String = e2.toFixed(2)

    return e2String.includes('.00') ? e2.toFixed(0) : e2String
  }

  INDRA_setCardlessScript() {
    if (this.myScriptElement1 || this.myScriptElement) {
      document.body.removeChild(this.myScriptElement1);
      document.body.removeChild(this.myScriptElement);
    }

    this.myScriptElement1 = document.createElement("script");
    this.myScriptElement1.src = `https://embedded.cardless.com/ecad/ecad.js`;

    this.myScriptElement = document.createElement("script");
    this.myScriptElement.textContent = `      
        window.ecad = window.ecad || []
        window.ecad.push({
          // set if you would like to provide a custom JWT to identify the user
          // ad will wait until this promise resolves before rendering
          identify: () => Promise.resolve("${this.cardlessToken}"),
      
          // required, for ad rendering and authorization
          parent: "#card_box",
          checkoutCost: ${this.TAP_convert(this.totalFlightPrice.cash)},

          /**
           * One of the following constraints must be met
           * 1. Non-empty product & utmCampaign values, or
           * 2. Non-empty brand value
           */
          brand: "${this.cardlessBrandTAP}",
          classOfService: "${this.cardlessClassOfService}",
          product: "${this.carldessProduct}",
          utmCampaign: "${this.cardlessUtmCampaign}",
      
          // optional, the Cardless environment to run against
          env: "${this.cardlessEnvironment}",
      
          // optional, for UI content customization
          uiMetadata: ${this.cardlessUiMetadata},

          /**
           * Optional: controls behavior when apply flow fires 
           * intent for returning to checkout. For "redirect", 
           * a valid URL or deep link must also be defined
           * 
           * @default "opener"
           * @see https://support.google.com/google-ads/answer/6046977
           */
          strategy: "${this.cardlessStrategy}",
          redirectURL: ${this.cardlessRedirectURL},
      
          /**
           * Optional handlers: for tying into state
           */
          onReady: () => console.log('[partner] ad frame ready'),
          onStart: () => console.log('[partner] apply flow started'),
          onOutcome: (data) => console.log('[partner] apply flow outcome %O', data),
          onPaymentMethodReady: (data) => console.log('[partner] payment method ready for use %O', data),
          onExit: () => console.log('[partner] apply flow exited'),
          onError: (e) => console.error('[partner] ad frame error', e),  })`;

    document.body.appendChild(this.myScriptElement1);
    document.body.appendChild(this.myScriptElement);

  }

  INDRA_setCardlessVariables() {
    // Set brand ID provided by Cardless from configuration
    // If no brand is set, use default
    const brand = this.ibeAdminConfigService.getConfigurationValue('bookingPayment.cardlessBrand');
    this.cardlessBrandTAP = brand ? brand : '2a1f3774-226d-49cd-8518-38215ced1bf0';

    // Get environment from configuration
    // Environment can be staging or production
    const environment = this.ibeAdminConfigService.getConfigurationValue('bookingPayment.cardlessEnv');
    this.cardlessEnvironment = environment === 'production' ? 'production' : 'staging';

    const classOfService = this.ibeAdminConfigService.getConfigurationValue('bookingPayment.cardlessClassOfService');
    this.cardlessClassOfService = classOfService ? classOfService : 'STANDARD';

    const product = this.ibeAdminConfigService.getConfigurationValue('bookingPayment.cardlessProduct');
    this.carldessProduct = product ? product : '45da1903-2ab1-496d-be70-1c498966f88a';

    const utmCampaign = this.ibeAdminConfigService.getConfigurationValue('bookingPayment.cardlessUtmCampaign');
    this.cardlessUtmCampaign = utmCampaign ? utmCampaign : 'tap-checkout';

    const uiMetadata = this.ibeAdminConfigService.getConfigurationValue('bookingPayment.cardlessUiMetadata');
    this.cardlessUiMetadata = uiMetadata ? uiMetadata : {"locale":"en-US"};

    const strategy = this.ibeAdminConfigService.getConfigurationValue('bookingPayment.cardlessStrategy');
    this.cardlessStrategy = strategy ? strategy : 'opener';

    const redirectURL = this.ibeAdminConfigService.getConfigurationValue('bookingPayment.cardlessRedirectURL');
    this.cardlessRedirectURL = redirectURL ? redirectURL : undefined;
  }
}